import { ShiftInformation } from "@/types/__generated__/union-types"

export const SHIFT_BACKGROUND_MAP: Record<ShiftInformation, string> = {
  OPERATIVE_SHIFT: "bg-primary",
  MEDICAL_SUPERVISOR: "bg-critical",
  NON_OPERATIVE_SHIFT: "bg-success",
}
